import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { ShoppingCart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCartCount } from "@/hooks/useCartCount";
import { UserMenu } from "@/components/UserMenu";
import logo from "@/assets/logo.png";

const linkCls = ({ isActive }) =>
  `px-3 py-2 text-sm font-medium transition-colors ${isActive ? "text-[#002fa7]" : "text-gray-700 hover:text-[#002fa7]"}`;

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const count = useCartCount();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2">
          <img src={logo} alt="Pranav Anand Enterprises" className="h-11 w-auto object-contain"/>
          <span className="font-heading font-semibold text-xl tracking-tight" style={{color:"#0e5a32"}}>Pranav Anand Enterprises</span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {user && user.role ? (
            <>
              <NavLink to="/catalog" className={linkCls} data-testid="nav-catalog">Catalog</NavLink>
              <NavLink to="/dashboard" className={linkCls} data-testid="nav-dashboard">Dashboard</NavLink>
              <NavLink to="/my-orders" className={linkCls} data-testid="nav-my-orders">My Orders</NavLink>
              <NavLink to="/invoices" className={linkCls} data-testid="nav-invoices">Invoices</NavLink>
              {user.role === "admin" && (
                <NavLink to="/admin" className={linkCls} data-testid="nav-admin">Admin</NavLink>
              )}
            </>
          ) : (
            <>
              <a href="/catalog" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#002fa7] transition-colors" data-testid="nav-products">Products</a>
              <a href="/#about" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#002fa7] transition-colors" data-testid="nav-about">About us</a>
              <a href="/#contact" className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-[#002fa7] transition-colors" data-testid="nav-contact">Contact</a>
            </>
          )}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/cart" className="relative p-2 hover:bg-gray-100 rounded-sm" data-testid="nav-cart">
            <ShoppingCart className="w-5 h-5" strokeWidth={1.5} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-[#002fa7] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">{count}</span>
            )}
          </Link>
          {user && user.role ? (
            <UserMenu user={user} onLogout={handleLogout} />
          ) : (
            <div className="flex items-center gap-2">
              <Link to="/login"><Button variant="ghost" size="sm" data-testid="nav-login" className="rounded-sm">Sign in</Button></Link>
              <Link to="/register"><Button size="sm" data-testid="nav-register" className="rounded-sm bg-[#002fa7] hover:bg-[#00227b]">Get started</Button></Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
